const MAX_COLLABORATORS = 3;

export const normalizeTopCollaboratorAccountIds = (
	accountIds: ReadonlyArray<string>,
): ReadonlyArray<string> =>
	accountIds
		.map((accountId) => accountId.trim())
		.filter(Boolean)
		.slice(0, MAX_COLLABORATORS);

export const parseTopCollaboratorAccountIds = (
	csv: string | null | undefined,
): ReadonlyArray<string> => normalizeTopCollaboratorAccountIds(csv ? csv.split(',') : []);
